import Skeleton from "@mui/material/Skeleton";

const EventsViewSkeleton = () => {
  return (
    <div className="bg-white w-full rounded-lg xl:col-span-4 col-span-12">
      <div>
        <Skeleton
          className="!bg-gray-300 rounded-t-lg"
          variant="rectangular"
          animation="wave"
          width={`w-full`}
          height={200}
        />
      </div>
      <div className="pl-2 pr-2 pt-4">
        <div className="text-lg font-semibold text-skin-title-insights mb-2">
          <Skeleton
            className="!bg-gray-300"
            variant="text"
            animation="wave"
            width={140}
            height={36}
          />
        </div>
      </div>
      <div className="px-2 pb-2">
        <Skeleton
          className="!bg-gray-300"
          variant="text"
          animation="wave"
          width={`w-full`}
          height={28}
        />
      </div>
      <div className="px-2 pb-2">
        <Skeleton
          className="!bg-gray-300"
          variant="text"
          animation="wave"
          width={`w-full`}
          height={28}
        />
      </div>
      <div className="px-2 pb-2">
        <Skeleton
          className="!bg-gray-300"
          variant="text"
          animation="wave"
          width={`w-full`}
          height={28}
        />
      </div>
      <div className="px-2 pb-2">
        <Skeleton
          className="!bg-gray-300"
          variant="text"
          animation="wave"
          width={`w-full`}
          height={28}
        />
      </div>
    </div>
  );
};
export default EventsViewSkeleton;
